import * as z from "zod/v4";

export const AiExchangeAgentAnalyticsInputSchema = z.object({});

export const AiExchangeAgentAnalyticsOutputSchema = z.object({
  beforeExchangeAgent: z.object({
    exchangeAgentLaunchDate: z
      .string()
      .describe("Date of launch of the exchange agent"),
    totalReturns: z.number().describe("Total number of returns"),
    totalExchanges: z.number().describe("Total number of exchanges"),
    totalRefundAmount: z
      .number()
      .describe("Total amount of refund value issued"),
    totalStoreCreditAmount: z
      .number()
      .describe("Total amount of store credit issued"),
    totalExchangeAmount: z.number().describe("Total amount of exchange value"),
  }),
  afterExchangeAgent: z.object({
    totalReturns: z.number().describe("Total number of returns"),
    totalExchanges: z.number().describe("Total number of exchanges"),
    totalExchangesFromAI: z
      .number()
      .describe(
        "Total number of exchanges that include suggested variants or recommended products from AI Exchange Agent",
      ),
    totalRefundAmount: z
      .number()
      .describe("Total amount of refund value issued"),
    totalStoreCreditAmount: z
      .number()
      .describe("Total amount of store credit issued"),
    totalExchangeAmount: z.number().describe("Total amount of exchange value"),
  }),
  exchangeAgentFeatureAnalytics: z.object({
    suggestedVariants: z.object({
      exchangedForSuggestedVariantCount: z
        .number()
        .describe("Total number of exchanges for suggested variants"),
    }),
    recommendedExchanges: z.object({
      exchangedForRecommendedProductCount: z
        .number()
        .describe("Total number of exchanges for recommended products"),
    }),
  }),
});

export type AiExchangeAgentAnalyticsInput = z.infer<
  typeof AiExchangeAgentAnalyticsInputSchema
>;
export type AiExchangeAgentAnalyticsOutput = z.infer<
  typeof AiExchangeAgentAnalyticsOutputSchema
>;

export const aiExchangeAgentAnalytics = {
  name: "getAiExchangeAgentAnalytics" as const,
  input: AiExchangeAgentAnalyticsInputSchema,
  output: AiExchangeAgentAnalyticsOutputSchema,
};
